import { axiosInstanceMain } from "../../../utils/axiosGlobalUtils";
import { ITenant } from "../../AbmLocalPage/types";

export const getAnuncios = async (idLocal: any, tenant:ITenant) => {
  return await axiosInstanceMain.get(
    `/${tenant.path}/anuncios/home-vendedor/${idLocal}`
  );
};
